import EmblaCarousel from 'embla-carousel';

Drupal.behaviors.groupedCarousel = {
  attach(context) {
    document.querySelectorAll('.view-units .views-group', context).forEach((groupEl) => {
      if (groupEl.classList.contains('carousel-initialized')) return;

      const slides = Array.from(groupEl.querySelectorAll('.views-row'));
      if (slides.length < 2) return;

      const container = document.createElement('div');
      container.classList.add('embla__container');

      slides.forEach((slide) => {
        slide.classList.add('embla__slide');
        container.appendChild(slide);
      });

      const viewport = document.createElement('div');
      viewport.classList.add('embla__viewport');
      viewport.appendChild(container);

      const prevBtn = document.createElement('button');
      prevBtn.classList.add('carousel-prev', 'arrow-black');

      const nextBtn = document.createElement('button');
      nextBtn.classList.add('carousel-next', 'arrow-black');

      groupEl.innerHTML = '';
      groupEl.appendChild(prevBtn);
      groupEl.appendChild(viewport);
      groupEl.appendChild(nextBtn);

      const embla = EmblaCarousel(viewport, {
        loop: false,
        align: 'start',
      });

      const updateHeight = () => {
        const index = embla.selectedScrollSnap();
        const slide = embla.slideNodes()[index];
        if (slide) {
          const height = slide.offsetHeight;
          viewport.style.height = `${height}px`;
        }
      };

      embla.on('select', updateHeight);
      embla.on('init', updateHeight);

      window.addEventListener('load', updateHeight);
      updateHeight();

      prevBtn.addEventListener('click', () => embla.scrollPrev());
      nextBtn.addEventListener('click', () => embla.scrollNext());

      groupEl.classList.add('carousel-initialized');
    });
  }
};
